import { Radio, Instagram, Twitter, Github } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-5">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-8 h-8 bg-[#B4FF39]">
              <Radio className="w-4 h-4 text-[#0A0A0A]" strokeWidth={2.5} />
            </span>
            <span className="font-display text-xl tracking-tighter">
              365<span className="text-[#B4FF39]">LIVE</span>
            </span>
          </div>
          <p className="text-sm text-zinc-400 max-w-sm leading-relaxed">
            The events platform tuned for nightlife, festivals, and culture.
            Discover what's live tonight — book it in two taps.
          </p>
          <div className="flex items-center gap-3 pt-2">
            <a href="#" data-testid="social-instagram" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-[#B4FF39] hover:text-[#B4FF39] transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" data-testid="social-twitter" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-[#B4FF39] hover:text-[#B4FF39] transition-colors">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" data-testid="social-github" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-[#B4FF39] hover:text-[#B4FF39] transition-colors">
              <Github className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-4">Platform</h4>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li><Link to="/events" className="hover:text-[#B4FF39]">Browse Events</Link></li>
            <li><Link to="/my-reservations" className="hover:text-[#B4FF39]">My Tickets</Link></li>
            <li><a href="#waitlist" className="hover:text-[#B4FF39]">Waitlist</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-4">Categories</h4>
          <div className="flex flex-wrap gap-2">
            {["Music Festival", "Nightlife", "Tech", "Arts", "Food", "Sports"].map((c) => (
              <Link
                key={c}
                to={`/events?category=${encodeURIComponent(c)}`}
                className="px-3 py-1 border border-white/10 text-xs uppercase tracking-wider text-zinc-300 hover:border-[#B4FF39] hover:text-[#B4FF39]"
              >
                {c}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <p data-testid="footer-copy">© 2026 365LIVE — Crafted for the night-owl economy.</p>
          <p className="font-mono-tight tracking-tight">v0.1 · MVP</p>
        </div>
      </div>
    </footer>
  );
}
